<div class="model-selector" [class.model-selector-loading]="!available_models.length">
  <button 
    mat-button 
    [matMenuTriggerFor]="menu" 
    class="model-selector-button"
    [attr.aria-label]="(selectedModel?.title || 'Loading')"
    [attr.aria-expanded]="menuOpen"
    (menuOpened)="menuOpen = true"
    (menuClosed)="menuOpen = false">
    <span class="model-name">{{ selectedModel?.title || 'Select Model' }}</span>
    <mat-icon>expand_more</mat-icon>
  </button>

  <mat-menu #menu="matMenu" class="model-selector-menu">
    <button
      mat-menu-item
      *ngFor="let model of available_models"
      (click)="selectModel(model)"
      [class.selected]="selectedModel?.name === model.name"
      [matTooltip]="model.description"
      matTooltipPosition="left"
      [attr.aria-label]="model.title + ': ' + model.description">
      <mat-icon>{{ getModelIcon(model) }}</mat-icon>
      <span class="mat-mdc-menu-item-text">
        <span>{{ model.title }}</span>
        <!-- Optional: Add model info like max tokens -->
        <span *ngIf="getModelCapabilities(model)">
          {{ getModelCapabilities(model) }}
        </span>
      </span>
    </button>
  </mat-menu>
</div>